var OpTypes = /*#__PURE__*/function (OpTypes) {
  OpTypes[OpTypes["delete"] = 0] = "delete";
  OpTypes[OpTypes["replace"] = 1] = "replace";
  return OpTypes;
}(OpTypes || {});
function compareObj(prevObj, newObj, path, result) {
  for (const key of Object.keys(newObj)) {
    const newVal = newObj[key];
    const prevVal = prevObj[key];
    if (prevVal === newVal) {
      continue;
    }
    compareUnknown(prevVal, newVal, path.concat(key), result);
  }
  for (const key of Object.keys(prevObj)) {
    if (!newObj[key]) {
      result.push({
        type: OpTypes.delete,
        path: path.concat(key)
      });
    }
  }
}
function compareUnknown(prev, newV, path, result) {
  if (newV === prev) {
    return;
  }
  const newType = typeof newV;
  if (newType !== typeof prev) {
    result.push({
      type: OpTypes.replace,
      val: newV,
      path
    });
    return;
  }
  if (Array.isArray(newV)) {
    result.push({
      type: OpTypes.replace,
      val: newV,
      path
    });
    return;
  }
  if (newV !== null && newType === 'object') {
    compareObj(prev, newV, path, result);
    return;
  }
  result.push({
    type: OpTypes.replace,
    val: newV,
    path
  }); // TODO arr
  return;
}
export function applyDiff(prev, diff) {
  for (const op of diff) {
    let point = prev;
    for (let pInd = 0; pInd < op.path.length; pInd++) {
      const p = op.path[pInd];
      if (pInd === op.path.length - 1) {
        switch (op.type) {
          case OpTypes.replace:
            point[p] = op.val;
            break;
          case OpTypes.delete:
            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
            delete point[p];
        }
      } else {
        point[p] = {
          ...point[p]
        };
        point = point[p];
      }
    }
  }
  return prev;
}
export function createDiff(prevObj, newObj) {
  const diff = [];
  compareObj(prevObj, newObj, [], diff);
  return diff;
}
//# sourceMappingURL=create-diff.js.map